import { Inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE, StorageTranscoders, WebStorageService } from 'ngx-webstorage-service';

export const CUSTOMER_ID = 'CID';
export const SITE_BOOKING_SETTINGS = 'siteSettings';
export const APPOINTMENT_REQUEST = 'appointmentRequest';
export const SUPPORTS_PETS = 'supportsPets';
@Injectable({
    providedIn: 'root',
})
export class LocalStorageService {
    constructor(@Inject(LOCAL_STORAGE) private storage: WebStorageService) {}

    public get(key: string): object {
        return this.storage.get(key);
    }
    public getString(key: string): string {
        const value = this.storage.get(key, StorageTranscoders.STRING);
        return this.removeDuplicateQuotes(value);
    }

    public clear(keys?: string[]): void {
        if (keys) {
            keys.forEach((val) => this.storage.remove(val));
        } else {
            this.storage.clear();
        }
    }

    public set(key: string, value: any): void {
        this.storage.set(key, value);
    }

    public setString(key: string, value: string): void {
        this.storage.set(key, value, StorageTranscoders.STRING);
    }

    public setNested(key: string, nestedKey: string, value: any): void {
        if (this.has(key)) {
            const fullValue = this.get(key) as any;
            fullValue[nestedKey] = value;

            this.set(key, fullValue);
        } else {
            const fullValue = {} as any;
            fullValue[nestedKey] = value;

            this.set(key, fullValue);
        }
    }

    public has(key: string): boolean {
        return this.storage.has(key);
    }

    public remove(key: string): void {
        this.storage.remove(key);
    }

    removeDuplicateQuotes(value: string) {
        if (value?.charAt(0) === '"') {
            value = JSON.parse(value);
        }
        return value;
    }
}
